import React, { useEffect, useState } from "react";
import "./events.scss";
import Jumbotron from "../../components/jumbotron/Jumbotron";
import useSanity, { TEvent } from "../../hooks/useSanity";
import EventCard from "../../components/eventCard/EventCard";
import Spinner from "../../components/spinner/Spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";

export default function Events() {
  const { getEvents } = useSanity();
  const [events, setEvents] = useState<Array<TEvent> | undefined>(undefined);

  useEffect(() => {
    window.scroll(0, 0);
    void getEvents()
      .then(res => setEvents(res))
      .catch(err => {
        console.error("Failed to fetch events:", err);
        setEvents(undefined);
      });
  }, []);

  return (
    <div>
      <Jumbotron
        title="Upcoming Events"
        content="Discover what’s happening — from promos to pop-ups and more. Join us and be part of the experience."
      />

      <div className="ui-events">
        {events === undefined ? (
          <Spinner />
        ) : events?.length === 0 ? (
          <div className="ui-events-none">
            <FontAwesomeIcon icon={faCalendar} /> No Events Found - Check Back Soon!
          </div>
        ) : (
          events?.map((e, index) => <EventCard key={index} salonEvent={e} />)
        )}
      </div>
    </div>
  );
}
